module.exports = __webpack_public_path__ + "4fd2276b.png";